// Using example from Tailwind UI: https://tailwindui.com/components/application-ui/elements/dropdowns
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Image from 'next/image';
import Link from 'next/link';
import { FaChevronDown, FaUserFriends, FaVideo } from 'react-icons/fa';
import { BsFillPersonFill, BsFillPeopleFill } from 'react-icons/bs';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function TeamSortDropdown({ onClick, current }) {
    const hidden = true;
    if (hidden) return (
        <></>
    );

    return (
        <Menu as="div" className="relative inline-block text-left z-30">
            <div>
                <Menu.Button className={`inline-flex items-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 ${current ? "bg-red-300" : "bg-red-400 hover:bg-red-300"} active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}>

                    {
                        current === "solo" && <><BsFillPersonFill className="w-4 h-4" /> Kooleyy</> ||
                        current === "team" && <><BsFillPeopleFill className="w-4 h-4" /> Continuity</> ||
                        <><FaVideo className="w-6 h-4" /> Editor</>
                    }
                    <FaChevronDown className="w-3" />
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="origin-top-right z-20 absolute right-0 md:left-0 mt-2 w-56 rounded-md shadow-lg bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                        <Menu.Item key="unsorted">
                            {({ active }) => (
                                <button
                                    className={`${classNames(
                                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                                        'block px-4 py-2 text-sm'
                                    )} flex flex-row gap-x-2 items-center w-full`}
                                    onClick={() => onClick(null)}
                                >
                                    <FaUserFriends className="w-8 h-8" />
                                    Everyone
                                </button>
                            )}
                        </Menu.Item>
                        <Menu.Item key="kooleyy">
                            {({ active }) => (
                                <button
                                    className={`${classNames(
                                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                                        'block px-4 py-2 text-sm'
                                    )} flex flex-row gap-x-2 items-center w-full`}
                                    onClick={() => onClick("solo")}
                                >
                                    <Image width="64" height="64" referrerPolicy="no-referrer" className="rounded-xl w-8 h-8" alt={"Kooleyy"} src={"/kooleyy.png"} unoptimized />
                                    Kooleyy
                                </button>
                            )}
                        </Menu.Item>
                        <Menu.Item key="team">
                            {({ active }) => (
                                <button
                                    className={`${classNames(
                                        active ? 'bg-gray-600 text-slate-100' : 'text-slate-100 hover:bg-gray-600',
                                        'block px-4 py-2 text-sm'
                                    )} flex flex-row gap-x-2 items-center w-full`}
                                    onClick={() => onClick("team")}
                                >
                                    <Image width="64" height="64" referrerPolicy="no-referrer" className="rounded-xl w-8 h-8" alt={"Kooleyy"} src={"/continuity.png"} unoptimized />
                                    Continuity
                                </button>
                            )}
                        </Menu.Item>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu>
    )
}